import Auth from '../auth/Auth';
import AwardReportInfo from '../models/AwardReportInfo';
import BidPeriodAwardReportInfo from "../models/BidPeriodAwardReportInfo";
import { WebClient } from './WebClient'

class ApiAwardReport extends WebClient {
    async getAwardReportInfo(): Promise<AwardReportInfo | undefined> {
        const url = "/document/award";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || undefined;
            }
            return undefined;
        }).catch(() => { return undefined; });
    }

     async getAwardReport(customerId): Promise<BidPeriodAwardReportInfo | undefined> {
        const url = `/customer/award/${customerId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || undefined;
            }
            return undefined;
        }).catch(() => { return undefined; });
    }
}

export default new ApiAwardReport();
